// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__soC_e","label":"Labeled_label__r4vkG","divider":"Labeled_divider__99JsS"};